import React from 'react'

export default class IconsDnDSelect extends React.Component {
    render() {
        let color = '#C8C5FE'
        if (this.props.color) color = this.props.color
        let className = 'icons-icon'
        return (
            <svg
                className={className}
                style={this.props.style}
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
            >
                <path
                    d='M10 7.6001L11.2 8.8001L12.4 7.6001'
                    stroke='black'
                    strokeWidth='1.25'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <rect
                    x='0.799988'
                    y='4.80005'
                    width='14.4'
                    height='6.4'
                    rx='0.8'
                    stroke='#0A0A0A'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </svg>
        )
    }
}
